import { logLevel } from './config';
import type { LogLevel } from './types';

const VERBOSITY: Record<LogLevel, number> = { silent: 0, error: 1, warn: 2, log: 3, debug: 4 };

const LABEL = '[Quarterzip]';

const DEBUG_STYLE = 'color: #8b9bb0'; // Debug is dimmed to let others stand out

type LogMethod = (...args: unknown[]) => void;

const noop: LogMethod = () => {};

const enabled = (of: LogLevel): boolean => VERBOSITY[logLevel()] >= VERBOSITY[of];

/** Each method is the bound console method itself, resolved on access. */
export const logger = {
	get debug(): LogMethod {
		return enabled('debug') ? console.debug.bind(console, `%c${LABEL}`, DEBUG_STYLE) : noop;
	},
	get log(): LogMethod {
		return enabled('log') ? console.log.bind(console, LABEL) : noop;
	},
	get warn(): LogMethod {
		return enabled('warn') ? console.warn.bind(console, LABEL) : noop;
	},
	get error(): LogMethod {
		return enabled('error') ? console.error.bind(console, LABEL) : noop;
	}
};
